<h2>
  <app-grid-quick-filter
    style="width: 350px"
    class="pull-right"
    [filterTypes]="quickFilters"
  ></app-grid-quick-filter>
  Payment Inventory
</h2>
<hr />

<div class="row">
  <div class="col-xs-12">
    <h4>Ready to Remit</h4>
    <app-ready-to-pay-list
      #readyToPay
      (generatePayment)="generatePayment($event)"
    ></app-ready-to-pay-list>
  </div>
</div>

<div class="row">
  <div class="col-xs-12">
    <h4>Generating Remittance</h4>
    <app-pending-payment-list #pendingPayment></app-pending-payment-list>
  </div>
</div>

<app-payment-details #paymentDetails></app-payment-details>
